import { render, staticRenderFns } from "./DatagraphDj.vue?vue&type=template&id=3844447e&scoped=true"
import script from "./DatagraphDj.vue?vue&type=script&lang=js"
export * from "./DatagraphDj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3844447e",
  null
  
)

export default component.exports